/* eslint-disable promise/param-names */
import Vue from 'vue';
import {
  ADMIN_GET_USERS_SUCCESS,
  ADMIN_GET_USERS_REQUEST,
  ADMIN_GET_USERS_ERROR,
  ADMIN_GET_USERTYPES_ERROR,
  ADMIN_DELETE_USER_REQUEST,
  ADMIN_DELETE_USER_SUCCESS,
  ADMIN_DELETE_USER_ERROR,
  ADMIN_GET_USERTYPES_REQUEST,
  ADMIN_GET_USERTYPES_SUCCESS,
  ADMIN_ADD_USERTYPE_ERROR,
  ADMIN_ADD_USERTYPE_REQUEST,
  ADMIN_ADD_USERTYPE_SUCCESS,
  ADMIN_USER_UPDATE_TAGS_REQUEST,
  ADMIN_USER_UPDATE_TAGS_SUCCESS,
  ADMIN_USER_UPDATE_TAGS_ERROR,
  ADMIN_USER_DETAIL_REQUEST,
  ADMIN_USER_DETAIL_SUCCESS,
  ADMIN_USER_DETAIL_ERROR,
  ADMIN_GET_PROVIDERS_ERROR,
  ADMIN_GET_PROVIDERS_REQUEST,
  ADMIN_GET_PROVIDERS_SUCCESS,
  ADMIN_USER_UPDATE_COMPANIES_ERROR,
  ADMIN_USER_UPDATE_COMPANIES_SUCCESS,
  ADMIN_USER_UPDATE_COMPANIES_REQUEST,
  ADMIN_USER_UPDATE_RESULTLINK_ERROR,
  ADMIN_USER_UPDATE_RESULTLINK_REQUEST,
  ADMIN_USER_UPDATE_RESULTLINK_SUCCESS
} from './actiontypes';
import adminApi from '../../../_services/api/administration';

const state = {
  users: [],
  currentUser: {},
  usertypes: [],
  status: '',
  errors: [],
  hasLoadedOnce: false,
};

const getters = {
  getUsers: state => state.users,
  getUserTypes: state => state.usertypes
};

const actions = {
  [ADMIN_GET_USERS_REQUEST]: ({ commit, dispatch }, payload={}) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_USERS_REQUEST);
      adminApi.getUsers(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_GET_USERS_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADMIN_GET_USERS_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_GET_USERS_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_ADD_USERTYPE_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_ADD_USERTYPE_REQUEST);
      adminApi.addUserType(payload)
          .then((response) => {
            if (response.success === true) {
              commit(ADMIN_ADD_USERTYPE_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(ADMIN_ADD_USERTYPE_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(ADMIN_GET_USERS_ERROR, error);
            reject(error);
          });
    });
  },
  [ADMIN_GET_PROVIDERS_REQUEST]: ({ commit, dispatch }, payload={}) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_PROVIDERS_REQUEST);
      adminApi.getProviders(payload)
          .then((response) => {
            if (response.success === true) {
              commit(ADMIN_GET_PROVIDERS_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(ADMIN_GET_PROVIDERS_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(ADMIN_GET_USERS_ERROR, error);
            reject(error);
          });
    });
  },
  [ADMIN_USER_DETAIL_REQUEST]: ({ commit, dispatch }, payload={}) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_USER_DETAIL_REQUEST);
      adminApi.getSpecificUser(payload)
          .then((response) => {
            if (response.success === true) {
              commit(ADMIN_USER_DETAIL_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(ADMIN_USER_DETAIL_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(ADMIN_USER_DETAIL_ERROR, error);
            reject(error);
          });
    });
  },
  [ADMIN_GET_USERTYPES_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_USERTYPES_REQUEST);
      adminApi.getUserTypes()
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_GET_USERTYPES_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADMIN_GET_USERTYPES_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_GET_USERTYPES_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_DELETE_USER_REQUEST]: ({ commit, dispatch }, userId) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_DELETE_USER_REQUEST);
      adminApi.deleteUser(userId)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_DELETE_USER_SUCCESS, response.data);
            dispatch(ADMIN_GET_USERS_REQUEST)
            resolve(response);
          } else {
            commit(ADMIN_DELETE_USER_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_DELETE_USER_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_USER_UPDATE_RESULTLINK_REQUEST]: ({ commit, dispatch }, payload={}) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_USER_UPDATE_RESULTLINK_REQUEST);
      adminApi.updateResultLink(payload)
          .then((response) => {
            if (response.success === true) {
              commit(ADMIN_USER_UPDATE_RESULTLINK_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(ADMIN_USER_UPDATE_RESULTLINK_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(ADMIN_USER_UPDATE_RESULTLINK_ERROR, error);
            reject(error);
          });
    });
  },
  [ADMIN_USER_UPDATE_TAGS_REQUEST]: ({ commit, dispatch }, payload={}) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_USER_UPDATE_TAGS_REQUEST);
      console.log('IM GOING TO CALL IT');
      adminApi.updateUserTag(payload)
          .then((response) => {
            if (response.success === true) {
              commit(ADMIN_USER_UPDATE_TAGS_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(ADMIN_USER_UPDATE_TAGS_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(ADMIN_USER_UPDATE_TAGS_ERROR, error);
            reject(error);
          });
    });
  },
  [ADMIN_USER_UPDATE_COMPANIES_REQUEST]: ({ commit, dispatch }, payload={}) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_USER_UPDATE_COMPANIES_REQUEST);
      adminApi.updateUserCompany(payload)
          .then((response) => {
            if (response.success === true) {
              commit(ADMIN_USER_UPDATE_COMPANIES_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(ADMIN_USER_UPDATE_COMPANIES_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(ADMIN_USER_UPDATE_COMPANIES_ERROR, error);
            reject(error);
          });
    });
  },
};

const mutations = {
  [ADMIN_ADD_USERTYPE_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_ADD_USERTYPE_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADMIN_ADD_USERTYPE_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_USER_UPDATE_RESULTLINK_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_USER_UPDATE_RESULTLINK_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADMIN_USER_UPDATE_RESULTLINK_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_USER_UPDATE_COMPANIES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_USER_UPDATE_COMPANIES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADMIN_USER_UPDATE_COMPANIES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_USER_UPDATE_TAGS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_USER_UPDATE_TAGS_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADMIN_USER_UPDATE_TAGS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_USER_DETAIL_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_USER_DETAIL_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'currentUser', response.user);
    state.hasLoadedOnce = true;
  },
  [ADMIN_USER_DETAIL_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_GET_USERS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_GET_USERS_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'users', response.users);
    state.hasLoadedOnce = true;
  },
  [ADMIN_GET_USERS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_GET_PROVIDERS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_GET_PROVIDERS_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'users', response.users);
    state.hasLoadedOnce = true;
  },
  [ADMIN_GET_PROVIDERS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_GET_USERTYPES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_GET_USERTYPES_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'usertypes', response.usertypes);
    state.hasLoadedOnce = true;
  },
  [ADMIN_GET_USERTYPES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_DELETE_USER_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_DELETE_USER_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADMIN_DELETE_USER_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
